import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { NewOwnersModule } from './widget/new-owners/new-owners.module';
import { WgActivitiesDistributionModule } from './widget/wg-activities-distribution/wg-activities-distribution.module';
import { WgSalesOffersModule } from './widget/wg-sales-offers/wg-sales-offers.module';
import { WgAccountAssignmentModule } from './widget/wg-account-assignment/wg-account-assignment.module';
import { WgNewAccountsModule } from './widget/wg-new-accounts/wg-new-accounts.module';
import { WgResidentialPropertyUpdatesModule } from './widget/wg-residential-property-updates/wg-residential-property-updates.module';
import { WgCommercialPropertyUpdatesModule } from './widget/wg-commercial-property-updates/wg-commercial-property-updates.module';
import { WgMyScheduleModule } from './widget/wg-my-schedule/wg-my-schedule.module';
import { WgAccountsStatisticsModule } from './widget/wg-accounts-statistics/wg-accounts-statistics.module';
import { WgOwnersStatisticsModule } from './widget/wg-owners-statistics/wg-owners-statistics.module';
import { WgPropertiesStatisticsModule } from './widget/wg-properties-statistics/wg-properties-statistics.module';
import { WgTicketsModule } from './widget/wg-tickets/wg-tickets.module';
import { WgResidentialInterestModule } from './widget/wg-residential-interest/wg-residential-interest.module';
import { WgAccountSourcesModule } from './widget/wg-account-sources/wg-account-sources.module';
import { WgCommercialInterestModule } from './widget/wg-commercial-interest/wg-commercial-interest.module';
import { WgInvoicesModule } from './widget/wg-invoices/wg-invoices.module';
import { WgActionableAccountsModule } from './widget/wg-actionable-accounts/wg-actionable-accounts.module';
import { IndexModule } from 'app/main/properties/index/index.module';
import { WgSalesModule } from './widget/wg-sales/wg-sales.module';
import { WgCoBrokersModule } from './widget/wg-co-brokers/wg-co-brokers.module';
import { PropertiesActionRequiredModule } from 'app/main/mls-dashboard/properties-action-required/properties-action-required.module';
import { IntercompanyRequestsModule } from 'app/main/mls-dashboard/intercompany-requests/intercompany-requests.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { OrderWidgetsComponent } from './order-widgets/order-widgets.component';
import { MatButtonModule } from '@angular/material/button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { WgActiveDossiersModule } from './widget/wg-active-dossiers/wg-active-dossiers.module';
import { WgInternalPoliciesModule } from './widget/wg-internal-policies/wg-internal-policies.module';
import { WgProceduresModule } from './widget/wg-procedures/wg-procedures.module';
import { WgEmployeesBgChecksModule } from './widget/wg-employe-bg-checks/wg-employees-bg-checks.module';
import { WgLearningResourcesModule } from './widget/wg-learning-resources/wg-learning-resources.module';
import { WgIndividualEmployeesStatusModule } from './widget/wg-individual-employe-status/wg-individual-employees-status.module';
import { WgAmlOfficerModule } from './widget/wg-aml-officer/wg-aml-officer.module';
import { WgReportingModule } from './widget/wg-reporting/wg-reporting.module';
import { WgWhistleblowerModule } from './widget/wg-whistleblower/wg-whistleblower.module';
import { WgStatisticsModule } from './widget/wg-statistics/wg-statistics.module';
import { WgCreditsModule } from './widget/wg-credits/wg-credits.module';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  }
];
@NgModule({
  declarations: [HomeComponent, OrderWidgetsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,

    NewOwnersModule,
    WgActivitiesDistributionModule,
    WgSalesOffersModule,
    WgAccountAssignmentModule,
    WgNewAccountsModule,
    WgResidentialPropertyUpdatesModule,
    WgCommercialPropertyUpdatesModule,
    WgMyScheduleModule,
    WgAccountsStatisticsModule,
    WgOwnersStatisticsModule,
    WgPropertiesStatisticsModule,
    WgTicketsModule,
    WgResidentialInterestModule,
    WgAccountSourcesModule,
    WgCommercialInterestModule,
    WgInvoicesModule,
    WgActionableAccountsModule,
    WgSalesModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    IndexModule,
    WgCoBrokersModule,
    PropertiesActionRequiredModule,
    IntercompanyRequestsModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    WgActiveDossiersModule,
    WgInternalPoliciesModule,
    WgProceduresModule,
    WgEmployeesBgChecksModule,
    WgLearningResourcesModule,
    WgIndividualEmployeesStatusModule,
    WgAmlOfficerModule,
    WgReportingModule,
    WgWhistleblowerModule,
    WgStatisticsModule,
    WgCreditsModule
  ]
})
export class HomeModule { }
